(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[14746,52892],{

/***/ 58699:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/thriftyadvice",
      function () {
        return __webpack_require__(54425);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 54425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ ThriftyAdviceHome; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/layouts/thriftyAdviceWrapper.tsx + 3 modules
var thriftyAdviceWrapper = __webpack_require__(68787);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/lib/sharedUtils.ts
var sharedUtils = __webpack_require__(75094);
// EXTERNAL MODULE: ./src/components/thriftyadvice/sharedButton/style.module.scss
var style_module = __webpack_require__(60319);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
;// CONCATENATED MODULE: ./src/components/thriftyadvice/sharedButton/index.tsx


function SharedButton({ children , href  }) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
        href: href,
        target: "_blank",
        className: `py-4 sm:px-16 px-4 sm:text-lg font-semibold rounded-[13px] ${(style_module_default()).animation} block text-center`,
        rel: "noreferrer",
        children: children
    });
}

// EXTERNAL MODULE: ./src/components/thriftyadvice/mainCategoryComponent/style.module.scss
var mainCategoryComponent_style_module = __webpack_require__(70235);
var mainCategoryComponent_style_module_default = /*#__PURE__*/__webpack_require__.n(mainCategoryComponent_style_module);
;// CONCATENATED MODULE: ./src/components/thriftyadvice/mainCategoryComponent/index.tsx





function MainCategoryComponent({ step  }) {
    const { title , img , buttonTitle , content , href  } = step;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "lg:mt-28 mt-14",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "font-bold lg:text-4xl text-2xl lg:leading-[45px] text-[#39A7AF] ",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (mainCategoryComponent_style_module_default()).contentStyle,
                children: content
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative mt-7",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: img,
                    alt: "Image",
                    layout: "responsive",
                    width: 900,
                    height: 504
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-10 md:max-w-[600px] mx-auto",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SharedButton, {
                    href: href,
                    children: buttonTitle
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/lib/shared/routerQueriesToString.ts
var routerQueriesToString = __webpack_require__(78418);
;// CONCATENATED MODULE: ./src/components/thriftyadvice/mainCategoryWrapper/index.tsx







function MainCategoriesWrapper() {
    const { query  } = (0,router.useRouter)();
    const queryString = (0,routerQueriesToString/* gettingQueriesAsString */.r)(query, "start");
    const mainCategoriesArray = [
        {
            title: "1. Understand Your Debt",
            img: "/thriftyadvice/assets/images/understandYourDebtSituation.jpg",
            content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            "Let's start by shedding light on your debt situation. Take a moment to relax, grab your financial statements, and sit down with a warm cup of coffee. It's time to calculate the full extent of your debts, from those persistently nagging credit card balances to the looming mortgage. Pay attention to the interest rates, as they are the silent accomplices of your financial difficulties. Now,",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: `https://debtreliefoffice.com/generic/find-out-the-minimum-monthly-payment-of-your-debt${queryString ? `?${queryString}` : ""}`,
                                target: "_blank",
                                rel: "noreferrer",
                                children: "tally up the minimum monthly payments."
                            }),
                            "."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            "You're now armed with a clear picture of your debt battlefield. Ready to face your",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: `https://debtreliefoffice.com/generic/find-out-the-minimum-monthly-payment-of-your-debt${queryString ? `?${queryString}` : ""}`,
                                target: "_blank",
                                rel: "noreferrer",
                                children: "debt head-on"
                            }),
                            " ",
                            "?"
                        ]
                    })
                ]
            }),
            buttonTitle: "Analyze My Debt",
            href: `https://debtreliefoffice.com/generic/find-out-the-minimum-monthly-payment-of-your-debt${queryString ? `?${queryString}` : ""}`
        },
        {
            title: "2. Explore Debt Relief Options",
            img: "/thriftyadvice/assets/images/exploringDebtReliefOptions.jpg",
            content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: 'Seniors have a wealth of debt relief options at their fingertips. Debt consolidation, debt settlement, and yes, even the "B" word (bankruptcy) may be in your arsenal. But remember, knowledge is power. Explore these options meticulously, and don\'t hesitate to seek professional advice. What works best for you will depend on your unique financial situation.'
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            "Ready to explore your debt relief options with a seasoned guide by your side? Our experienced advisors are just a phone call away.",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: `https://debtreliefoffice.com/generic/accredited-debt-relief-advisors-around-me${queryString ? `?${queryString}` : ""}`,
                                target: "_blank",
                                rel: "noreferrer",
                                children: "Reach out today"
                            }),
                            " ",
                            "to start your personalized journey to financial freedom."
                        ]
                    })
                ]
            }),
            buttonTitle: "What Are My Debt Relief Options?",
            href: `https://debtreliefoffice.com/generic/accredited-debt-relief-advisors-around-me${queryString ? `?${queryString}` : ""}`
        },
        {
            title: "3. Discover Special Tax Relief Programs for Seniors",
            img: "/thriftyadvice/assets/images/taxDebtRelief.jpg",
            content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Tax debt can feel like an anchor, weighing down your financial stability in retirement. However, there is hope on the horizon. Tax relief strategies are specifically designed to assist seniors in alleviating their financial burdens. These customized strategies offer a much-needed respite from the stress of dealing with tax debt."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: `https://taxdebtoffers.com/generic/discover-special-tax-relief-programs-for-seniors${queryString ? `?${queryString}` : ""}`,
                                children: "Explore your options"
                            }),
                            " ",
                            "to help reduce, and in some cases eliminate, tax issues, ranging from filing or correcting a tax return to arrangements like penalty abatement, installment agreements, or offers in compromise."
                        ]
                    })
                ]
            }),
            buttonTitle: "Discover Tailored Tax Debt Solutions for Seniors",
            href: `https://taxdebtoffers.com/generic/customized-tax-relief-strategies-for-seniors${queryString ? `?${queryString}` : ""}`
        },
        {
            title: "4. Stay Ahead of Costly Home Repair Bills: The Warranty Way",
            img: "/thriftyadvice/assets/images/homeRepairBills.jpg",
            content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "When crucial appliances take an unplanned break, it's not just about the inconvenience. It's the frantic search for reliable technicians and the unexpected dent in your wallet. Most home insurance policies step back right when you wish they'd step up."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            "But here's the modern homeowner's edge:",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: `https://homewarrantyforless.com/generic/unlock-big-savings-with-tailored-home-warranty${queryString ? `?${queryString}` : ""}`,
                                target: "_blank",
                                rel: "noreferrer",
                                children: "Home Warranty for Less."
                            }),
                            " ",
                            "More than just a policy, it's peace of mind on standby. It sidesteps DIY mishaps, technician hunting, and surprise costs. Whether it's swift appliance replacements or boosting your home's future resale value, this warranty has your back. Your home, your rules, minus the unpredictability"
                        ]
                    })
                ]
            }),
            buttonTitle: "Start Saving Thousands on Home Repairs",
            href: `https://homewarrantyforless.com/generic/save-thousands-on-home-repairs${queryString ? `?${queryString}` : ""}`
        },
        {
            title: "5. Unexpected Car Breakdowns: The Hidden Cost You Can't Afford to Overlook",
            img: "/thriftyadvice/assets/images/hiddenCostManyOverlook.jpg",
            content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            "For most car owners, especially those with vehicles that have seen their share of miles, unexpected repair bills hit the hardest. As our cars age, the need for repairs becomes more frequent, and the costs only seem to climb. While diligent car owners might keep up with regular maintenance, they may be overlooking the",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: `https://carwarrantyprices.com/generic/Save-big-on-car-protection-plans${queryString ? `?${queryString}` : ""}`,
                                target: "_blank",
                                rel: "noreferrer",
                                children: "potential savings"
                            }),
                            " ",
                            "a comprehensive auto warranty can offer."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "In fact, if you've been dipping into your savings for auto repairs more than a couple of times a year, there's a good chance you're spending more than you should. But here's the catch: many don't realize the potential savings at their fingertips."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            "Thanks to new and",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: `https://carwarrantyprices.com/generic/find-specialized-auto-warranty-providers-in-your-area${queryString ? `?${queryString}` : ""}`,
                                target: "_blank",
                                rel: "noreferrer",
                                children: "specialized auto warranty providers,"
                            }),
                            " ",
                            "many car owners are discovering they can save significantly in the long run. This isn't about simple coverage—it's about investing in your vehicle's longevity and peace of mind. And the best part? Finding out just how much you can save is easier than ever."
                        ]
                    })
                ]
            }),
            buttonTitle: "Discover Potential Savings With Auto Warranties Today",
            href: `https://carwarrantyprices.com/generic/discover-the-potential-savings-with-car-warranty-today${queryString ? `?${queryString}` : ""}`
        },
        {
            title: "6. Navigating Life Insurance in Your Golden Years: What US Seniors Need to Know",
            img: "/thriftyadvice/assets/images/lifeInsurance.jpg",
            content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Many seniors wonder if life insurance is necessary during retirement. The answer lies in your individual circumstances and the financial protection you wish to leave for your family. Life insurance can provide financial security for loved ones by covering funeral expenses and outstanding debts."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            "There are many misconceptions about life insurance, especially when it comes to seniors. Some believe it's too expensive or difficult to obtain as they age. However,",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: `https://insurancesupersaver.com/life${queryString ? `?${queryString}` : ""}`,
                                children: "many affordable options are available,"
                            }),
                            " ",
                            "and policies can often be tailored to meet your specific needs."
                        ]
                    })
                ]
            }),
            buttonTitle: "Secure Your Legacy with Our Expert Life Insurance Plans",
            href: `https://insurancesupersaver.com/life/generic/senior%27s-ultimate-guide-for-life-insurance-policies${queryString ? `?${queryString}` : ""}`
        }, 
    ];
    const month = sharedUtils/* monthsArr */.Wp[new Date().getMonth() - 1];
    const year = new Date().getFullYear();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "font-bold lg:text-5xl text-3xl lg:leading-[55px] text-black ",
                children: "Seniors' Guide to Financial Peace: Navigating Debt Relief Solutions"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "text-[#bababa] mt-4 block",
                children: [
                    "by",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "font-bold lg:text-lg text-base text-[#000]",
                        children: "David I. Morin"
                    }),
                    " ",
                    month,
                    ", ",
                    year
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: `relative  mt-2 `,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: "/thriftyadvice/assets/images/mainImg.jpg",
                    layout: "responsive",
                    width: 900,
                    height: 504,
                    alt: "Image"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mt-7 font-light lg:text-lg text-base lg:leading-8 ",
                children: "Were you born before 1965? If so, your financial future could be on the line, and you can't afford to miss out! The transition from a lifetime of hard work to a well-earned retirement can be a make-or-break moment for your economic well-being. But don't worry; we've got five must-do suggestions to help you secure your financial horizon."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "lg:mb-[127px] mb-[60px]",
                children: mainCategoriesArray.map((step, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(MainCategoryComponent, {
                        step: step
                    }, index))
            })
        ]
    });
}

;// CONCATENATED MODULE: ./pages/thriftyadvice/index.tsx




var __N_SSP = true;
function ThriftyAdviceHome() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(thriftyAdviceWrapper/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MainCategoriesWrapper, {})
    });
}


/***/ }),

/***/ 78418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ gettingQueriesAsString; }
/* harmony export */ });
const gettingQueriesAsString = (query, location, excludeList)=>{
    const initialValue = "";
    return Object.keys(query).reduce(function(previousValue, currentValue, index) {
        const value = query[currentValue];
        if (excludeList?.includes(currentValue)) {
            return previousValue;
        }
        return previousValue + `${index !== 0 ? "&" : ""}${currentValue}=${value}`;
    }, initialValue);
};


/***/ }),

/***/ 70235:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"contentStyle":"style_contentStyle__YhDjS"};

/***/ }),

/***/ 60319:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"animation":"style_animation__k_L_H"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [57079,51132,49774,92888,40179], function() { return __webpack_exec__(58699); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);